// Mock data for MAG Facility Services UG - Gebäudereinigung Augsburg

export const logoUrl =
  "https://customer-assets.emergentagent.com/job_property-care-53/artifacts/tyw65nk3_LOGO%20M.A.G%20%28Desktop-Hintergrund%29.PNG";

export const navLinks = [
  { label: "Leistungen", href: "/#leistungen" },
  { label: "Über uns", href: "/ueber-uns" },
  { label: "Referenzen", href: "/referenzen" },
  { label: "Kontakt", href: "/#kontakt" },
];

export const heroFeatures = [
  { icon: "ShieldCheck", title: "Versichert", subtitle: "Volle Haftpflicht" },
  { icon: "Sparkles", title: "Zertifiziert", subtitle: "Geschultes Team" },
  { icon: "Clock", title: "Pünktlich", subtitle: "Termintreue" },
];

export const trustBar = [
  { icon: "ShieldCheck", label: "Voll versichert" },
  { icon: "BadgeCheck", label: "Zertifiziertes Fachpersonal" },
  { icon: "Leaf", label: "Umweltfreundliche Mittel" },
  { icon: "BadgeEuro", label: "Faire, transparente Preise" },
  { icon: "Clock", label: "24/7 Notfallservice" },
];

export const services = [
  {
    id: "unterhaltsreinigung",
    slug: "unterhaltsreinigung-augsburg",
    title: "Unterhaltsreinigung",
    tag: "Kernleistung",
    featured: true,
    icon: "Sparkles",
    image:
      "https://images.unsplash.com/photo-1669101602124-f5b78895d91c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900&h=1200&fit=crop",
    short:
      "Tägliche und wöchentliche Reinigung für Büros, Praxen und Gewerbeobjekte. Individuell nach Ihrem Rhythmus.",
    bullets: ["Böden, Sanitär, Küchen", "Nach VDI 6022 hygienisch", "Feste Ansprechperson"],
    details:
      "Wir übernehmen die regelmäßige Reinigung Ihrer Räumlichkeiten – von Böden über Sanitäranlagen bis hin zu Küchen und Gemeinschaftsflächen. Nach einem individuell abgestimmten Reinigungsplan sorgen wir für konstante Sauberkeit und ein angenehmes Arbeitsumfeld.",
    long:
      "Die Unterhaltsreinigung ist das Herzstück eines gepflegten Objekts. Wir stimmen Intervalle, Uhrzeiten und Leistungsumfang exakt auf Ihren Betrieb ab – ob täglich, mehrmals wöchentlich oder nach Bedarf. So bleibt Ihr Büro, Ihre Praxis oder Ihr Ladenlokal dauerhaft sauber, hygienisch und repräsentativ.",
  },
  {
    id: "treppenhausreinigung",
    slug: "treppenhausreinigung-augsburg",
    title: "Treppenhausreinigung",
    icon: "Building2",
    short: "Regelmäßige Pflege von Treppenhäusern in Wohn- und Bürogebäuden.",
    bullets: ["Böden & Geländer", "Fenster im Treppenhaus", "Regelmäßige Intervalle"],
    details:
      "Saubere Treppenhäuser hinterlassen den ersten Eindruck. Wir reinigen Stufen, Geländer, Fenster und Eingangsbereiche in verlässlichen Intervallen – für Wohnanlagen und Bürogebäude gleichermaßen.",
    long:
      "Gerade in Mehrfamilienhäusern und Bürogebäuden ist ein gepflegtes Treppenhaus die Visitenkarte des Objekts. Wir übernehmen die turnusmäßige Reinigung inklusive Eingangsbereich, Aufzug und Kellerfluren – zuverlässig und dokumentiert.",
  },
  {
    id: "glasreinigung",
    slug: "glasreinigung-augsburg",
    title: "Glasreinigung",
    icon: "PanelsTopLeft",
    short: "Streifenfreie Fenster, Fassaden und Glasflächen – auch in Höhe.",
    bullets: ["Fenster & Rahmen", "Glasfassaden", "Höhenarbeiten möglich"],
    details:
      "Streifenfreie Fenster und glänzende Glasfassaden – mit modernem Equipment reinigen wir auch schwer zugängliche Glasflächen in der Höhe, sicher und gründlich.",
    long:
      "Von der einzelnen Fensterfront bis zur kompletten Glasfassade: Wir arbeiten mit professionellem Equipment und – wo nötig – mit Teleskoptechnik oder gesicherten Höhenarbeiten. Rahmen und Fensterbänke reinigen wir selbstverständlich mit.",
  },
  {
    id: "grundreinigung",
    slug: "grundreinigung-augsburg",
    title: "Grundreinigung",
    icon: "Droplets",
    short: "Intensive Tiefenreinigung für Böden, Teppiche und stark beanspruchte Bereiche.",
    bullets: ["Tiefenreinigung Böden", "Teppich & Polster", "Beschichtungen"],
    details:
      "Bei der Grundreinigung entfernen wir hartnäckige Verschmutzungen und Ablagerungen. Ideal für stark beanspruchte Bereiche, Teppiche und Böden, die eine intensive Auffrischung benötigen.",
    long:
      "Die Grundreinigung geht deutlich tiefer als die Unterhaltsreinigung: Wir entfernen alte Pflegefilme, hartnäckige Verschmutzungen und Ablagerungen und bringen Ihre Böden auf Wunsch anschließend mit einer schützenden Beschichtung wieder auf Hochglanz.",
  },
  {
    id: "baureinigung",
    slug: "baureinigung-augsburg",
    title: "Baureinigung",
    icon: "HardHat",
    short: "Bauzwischen- und Bauendreinigung inklusive Erstreinigung nach Renovation.",
    bullets: ["Bauzwischenreinigung", "Bauendreinigung", "Erstreinigung"],
    details:
      "Nach Bau- und Renovierungsarbeiten bringen wir Ihr Objekt bezugsfertig auf Hochglanz – von der Bauzwischenreinigung bis zur finalen Bauendreinigung.",
    long:
      "Ob Neubau, Umbau oder Sanierung – wir entfernen Baustaub, Kleberreste, Farbspritzer und Etiketten und übergeben Ihnen ein bezugsfertiges Objekt. Auf Wunsch inklusive Feinreinigung aller Oberflächen, Fenster und Sanitäranlagen.",
  },
  {
    id: "muellentsorgung",
    slug: "muellentsorgung-augsburg",
    title: "Müllentsorgung",
    icon: "Trash2",
    short: "Zuverlässige Entsorgung, Trennung und Containerbewirtschaftung.",
    bullets: ["Abfalltrennung", "Containermanagement", "Zuverlässige Abholung"],
    details:
      "Wir organisieren die fachgerechte Entsorgung und Trennung Ihrer Abfälle sowie die Bewirtschaftung von Containern – umweltbewusst und zuverlässig.",
    long:
      "Wir kümmern uns um die regelmäßige Leerung, korrekte Trennung und fachgerechte Entsorgung Ihrer Abfälle sowie um die Bewirtschaftung Ihrer Container- und Müllstellplätze – sauber, geruchsarm und zuverlässig.",
  },
  {
    id: "sonderreinigungen",
    slug: "sonderreinigungen-augsburg",
    title: "Sonderreinigungen",
    icon: "Wrench",
    short: "Individuelle Aufträge – Küchen, Werkstätten, Events, Notfallreinigung.",
    bullets: ["Küchen & Werkstätten", "Event-Reinigung", "Notfalleinsätze"],
    details:
      "Ob Großküche, Werkstatt, Event oder akuter Notfall – wir stellen uns flexibel auf individuelle Anforderungen ein und sind auch kurzfristig für Sie im Einsatz.",
    long:
      "Manche Aufgaben passen in kein Standardschema – genau dafür sind wir da. Von der Küchentiefenreinigung über Werkstatt- und Hallenböden bis zur kurzfristigen Notfallreinigung nach Wasser- oder Sturmschäden reagieren wir flexibel und schnell.",
  },
  {
    id: "industriereinigung",
    slug: "industriereinigung-augsburg",
    title: "Industrie- & Hallenreinigung",
    icon: "Factory",
    short: "Reinigung von Produktions- und Lagerhallen, Maschinen und Industrieböden.",
    bullets: ["Hallen- & Bodenreinigung", "Maschinen & Anlagen", "Nach Ihren Sicherheitsvorgaben"],
    details:
      "Wir reinigen Produktions- und Lagerhallen, Industrieböden sowie Maschinen und Anlagen – auch außerhalb Ihrer Betriebszeiten, um Ihren Ablauf nicht zu stören.",
    long:
      "Industrieumgebungen stellen besondere Anforderungen. Mit geeigneter Technik und geschultem Personal reinigen wir große Hallenflächen, beschichtete Industrieböden und Maschinenumfelder – unter Beachtung Ihrer Sicherheits- und Hygienevorgaben und gerne im Schicht- oder Wochenendbetrieb.",
  },
  {
    id: "fassadenreinigung",
    slug: "fassadenreinigung-augsburg",
    title: "Fassadenreinigung",
    icon: "Building",
    short: "Schonende Reinigung von Fassaden aus Putz, Klinker, Metall oder Glas.",
    bullets: ["Putz, Klinker & Metall", "Algen- & Grünbelagentfernung", "Höhenarbeiten möglich"],
    details:
      "Wir befreien Ihre Fassade schonend von Schmutz, Algen und Grünbelägen und lassen Ihr Gebäude wieder wie neu erstrahlen – materialgerecht und gründlich.",
    long:
      "Witterung, Abgase und Grünbewuchs setzen jeder Fassade zu. Wir wählen das passende Verfahren für Ihren Untergrund – von der Niederdruck- bis zur Spezialreinigung – und entfernen Verschmutzungen sowie Algen und Moose materialschonend, auf Wunsch inklusive Imprägnierung.",
  },
  {
    id: "photovoltaikreinigung",
    slug: "photovoltaikreinigung-augsburg",
    title: "Photovoltaik-Reinigung",
    icon: "Sun",
    short: "Mehr Ertrag durch saubere Solar- und PV-Module – schonend gereinigt.",
    bullets: ["Mehr Stromertrag", "Schonende Reinigung", "Entkalktes Reinwasser"],
    details:
      "Verschmutzte Solarmodule verlieren an Leistung. Wir reinigen Ihre Photovoltaikanlage schonend mit entkalktem Reinwasser und sorgen so für optimalen Ertrag.",
    long:
      "Staub, Pollen, Laub und Vogelkot mindern den Wirkungsgrad Ihrer PV-Anlage spürbar. Mit entkalktem Reinwasser und weichen Bürsten reinigen wir Ihre Module streifen- und rückstandsfrei – für einen dauerhaft höheren Stromertrag und eine längere Lebensdauer der Anlage.",
  },
  {
    id: "hausmeisterservice",
    slug: "hausmeisterservice-augsburg",
    title: "Hausmeisterservice",
    icon: "Hammer",
    short: "Zuverlässige Objektbetreuung, kleine Reparaturen und Außenpflege.",
    bullets: ["Objektbetreuung", "Kleinreparaturen", "Außenanlagen & Grünpflege"],
    details:
      "Von der Objektkontrolle über kleine Reparaturen bis zur Pflege der Außenanlagen – unser Hausmeisterservice hält Ihre Immobilie rundum in Schuss.",
    long:
      "Unser Hausmeisterservice entlastet Eigentümer und Verwaltungen: Wir übernehmen regelmäßige Kontrollgänge, kleine Reparaturen, die Pflege der Außenanlagen sowie die Koordination von Handwerkern – für einen dauerhaft gepflegten und werterhaltenden Zustand Ihrer Immobilie.",
  },
  {
    id: "winterdienst",
    slug: "winterdienst-augsburg",
    title: "Winterdienst",
    icon: "Snowflake",
    short: "Räum- und Streudienst für sichere Wege, Zufahrten und Parkplätze.",
    bullets: ["Schneeräumung", "Streuen bei Glätte", "Rechtssichere Dokumentation"],
    details:
      "Wir übernehmen Ihre Räum- und Streupflicht: Zuverlässige Schneeräumung und Glättebekämpfung für sichere Wege – inklusive Dokumentation.",
    long:
      "Als Eigentümer tragen Sie die Räum- und Streupflicht. Wir übernehmen diese verlässlich: Früh morgens und bei Bedarf mehrmals täglich sorgen wir für schnee- und eisfreie Gehwege, Zufahrten und Parkplätze – inklusive rechtssicherer Dokumentation der Einsätze.",
  },
  {
    id: "teppichreinigung",
    slug: "teppich-polsterreinigung-augsburg",
    title: "Teppich- & Polsterreinigung",
    icon: "Brush",
    short: "Tiefenreinigung von Teppichböden, Polstermöbeln und Sitzgruppen.",
    bullets: ["Sprüh-Extraktion", "Fleckentfernung", "Schnelle Trocknung"],
    details:
      "Mit professioneller Sprüh-Extraktion entfernen wir Schmutz, Flecken und Gerüche aus Teppichen und Polstern – für ein frisches, hygienisches Ergebnis.",
    long:
      "Teppiche und Polster binden Staub, Milben und Gerüche. Mit dem Sprüh-Extraktionsverfahren lösen und entfernen wir Verschmutzungen tief aus dem Gewebe – schonend zum Material und mit kurzer Trocknungszeit, damit Ihre Räume schnell wieder nutzbar sind.",
  },
];

export const aboutFeatures = [
  {
    icon: "UserCheck",
    title: "Feste Ansprechperson",
    text: "Sie erhalten einen persönlichen Objektleiter, der Qualität und Termine sichert.",
  },
  {
    icon: "FileCheck",
    title: "Transparente Abläufe",
    text: "Dokumentierte Reinigungspläne, klare Kommunikation, faire Angebote.",
  },
  {
    icon: "Leaf",
    title: "Nachhaltige Reinigung",
    text: "Umweltfreundliche Reinigungsmittel und effiziente Prozesse.",
  },
  {
    icon: "Zap",
    title: "Kurzfristige Verfügbarkeit",
    text: "Auch für Sondereinsätze und Notfälle innerhalb weniger Stunden vor Ort.",
  },
];

export const stats = [
  { value: 8, suffix: "+", label: "Jahre Erfahrung" },
  { value: 500, suffix: "+", label: "Zufriedene Kunden" },
  { value: 99, suffix: "%", label: "Zuverlässigkeit" },
  { value: 24, suffix: "/7", label: "Erreichbarkeit" },
];

export const testimonials = [
  {
    quote:
      "Seit wir mit MAG zusammenarbeiten, ist unser Bürogebäude in einem konstant makellosen Zustand. Absolut verlässlich.",
    name: "Sabine Krüger",
    role: "Office Manager, MERIDIAN GmbH",
  },
  {
    quote:
      "Kurzfristige Sonderreinigung nach einem Wasserschaden – innerhalb von 3 Stunden vor Ort. Vielen Dank!",
    name: "Marc Vogler",
    role: "Facility Director, HELIOS AG",
  },
  {
    quote:
      "Professionelle Kommunikation, faire Preise, sauberes Ergebnis. Wir empfehlen MAG uneingeschränkt weiter.",
    name: "Julia Weiss",
    role: "Geschäftsführung, BAUWERK+",
  },
];

export const contactInfo = {
  phone: "0155 6297 4055",
  phoneHref: "tel:+4915562974055",
  whatsappHref: "https://wa.me/4915562974055",
  email: "info@mag-facilityservices.de",
  address: "Wemdinger Weg 2, 86154 Augsburg",
  mapHref:
    "https://www.google.com/maps/search/?api=1&query=Wemdinger+Weg+2+86154+Augsburg",
};

export const rating = {
  score: "5,0",
  max: "5,0",
  caption: "Von unseren Kunden bestens bewertet",
};

export const openingHours = [
  { day: "Montag – Freitag", time: "07:00 – 18:00 Uhr" },
  { day: "Samstag", time: "Nach Vereinbarung" },
  { day: "Sonntag", time: "Geschlossen" },
  { day: "Notdienst", time: "24 / 7 erreichbar" },
];

export const serviceAreas = [
  "Augsburg",
  "Königsbrunn",
  "Stadtbergen",
  "Neusäß",
  "Gersthofen",
  "Friedberg",
  "Bobingen",
  "Schwabmünchen",
  "Aichach",
  "Mering",
  "Kissing",
  "Landsberg am Lech",
];

export const faqs = [
  {
    q: "Wie schnell erhalte ich ein Angebot?",
    a: "In der Regel melden wir uns innerhalb von 24 Stunden nach Ihrer Anfrage mit einem individuellen, transparenten Angebot bei Ihnen.",
  },
  {
    q: "Sind Sie versichert?",
    a: "Ja. Wir verfügen über eine vollständige Betriebshaftpflichtversicherung. Sollte doch einmal etwas passieren, sind Sie umfassend abgesichert.",
  },
  {
    q: "In welchen Gebieten sind Sie tätig?",
    a: "Wir sind in Augsburg und im gesamten Umland im Einsatz – u. a. in Königsbrunn, Stadtbergen, Gersthofen, Friedberg, Neusäß und weiteren Orten der Region.",
  },
  {
    q: "Bieten Sie auch kurzfristige oder Notfall-Reinigungen an?",
    a: "Ja. Über unseren Notdienst sind wir rund um die Uhr erreichbar und in vielen Fällen innerhalb weniger Stunden vor Ort.",
  },
  {
    q: "Verwenden Sie umweltfreundliche Reinigungsmittel?",
    a: "Wo immer möglich setzen wir auf umweltschonende Reinigungsmittel und effiziente Prozesse – für ein sauberes Ergebnis und ein gutes Gewissen.",
  },
  {
    q: "Wie erfolgt die Abrechnung?",
    a: "Sie erhalten transparente Angebote ohne versteckte Kosten. Die Abrechnung erfolgt nach Vereinbarung – individuell auf Ihr Objekt abgestimmt.",
  },
];

// Offene Stellen
export const jobs = [
  {
    id: "reinigungskraft-teilzeit",
    title: "Reinigungskraft (m/w/d) – Teilzeit",
    type: "Teilzeit",
    location: "Augsburg & Umgebung",
    intro:
      "Zur Verstärkung unseres Teams suchen wir zuverlässige Reinigungskräfte in Teilzeit für die Unterhalts- und Objektreinigung.",
    tasks: [
      "Unterhaltsreinigung von Büros, Praxen und Gewerbeobjekten",
      "Reinigung von Sanitär-, Küchen- und Gemeinschaftsflächen",
      "Sorgfältiges Arbeiten nach Reinigungsplan",
    ],
    profile: [
      "Zuverlässigkeit und Sorgfalt",
      "Erste Erfahrung in der Reinigung von Vorteil (kein Muss)",
      "Freundliches Auftreten, Teamgeist",
      "Führerschein von Vorteil",
    ],
    offer: [
      "Faire, pünktliche Bezahlung",
      "Feste Ansprechperson & geregelte Arbeitszeiten",
      "Arbeitskleidung & Einarbeitung",
      "Wohnortnahe Einsätze",
    ],
  },
  {
    id: "reinigungskraft-minijob",
    title: "Reinigungskraft (m/w/d) – Minijob",
    type: "Minijob (538 €)",
    location: "Augsburg & Umgebung",
    intro:
      "Sie suchen einen flexiblen Nebenjob? Wir suchen Reinigungskräfte auf Minijob-Basis für Einsätze in Augsburg und Umgebung.",
    tasks: [
      "Unterhalts- und Treppenhausreinigung",
      "Reinigung nach abgestimmtem Zeitplan",
      "Auffüllen von Verbrauchsmaterialien",
    ],
    profile: [
      "Zuverlässigkeit und Pünktlichkeit",
      "Flexibilität bei den Einsatzzeiten",
      "Freude an sauberer, gründlicher Arbeit",
    ],
    offer: [
      "Attraktive Bezahlung auf Minijob-Basis",
      "Flexible, planbare Arbeitszeiten",
      "Einarbeitung & Arbeitskleidung",
      "Freundliches Team",
    ],
  },
];

export const heroImage =
  "https://images.unsplash.com/photo-1721620958961-cccc239cbb49?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export const aboutImage =
  "https://images.unsplash.com/photo-1627905646269-7f034dcc5738?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000";
